<template>
  <qx-card-form title="申请信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <!-- 维修站点 -->
      <section slot="site" slot-scope="prop">
        <ChooseSite :isRadio="true" v-model="prop.form.site" @change="handleSiteChange" />
      </section>
      <!-- 维修站点 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import ChooseSite from 'components/choose/site';
export default {
  components: {
    ChooseSite,
  },
  data () {
    return {
      baseForm: {
        applyTypeOptions: [], // 费用类型
        stateOptions: [], // 维保状态
        orgIdOptions: [], // 费用归属
        form: [
          {
            label: '费用类型',
            value: 'applyType',
            type: 'select',
          },
          {
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            onChange: () => {
              this.handleOrgIdChange();
            },
          },
          {
            label: '维修站点',
            value: 'site',
            default: {},
            slot: true,
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            disabled: true,
          },
          {
            label: '费用归属日期',
            value: 'feeAscriptionDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '申请原因',
            value: 'repairReson',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '费用说明',
            value: 'amtRemark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'afterPicFile',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
        ],
        rules: {
          applyType: [ // 费用类型
            { required: true, message: '请选择费用类型', trigger: 'blur' },
          ],
          orgId: [ // 费用归属
            { required: true, message: '请选择费用归属', trigger: 'blur' },
          ],
          site: [ // 维修站点
            { required: true, message: '请选择维修站点', trigger: 'blur' },
          ],
          serviceName: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 费用归属日期
            { required: true, message: '请选择费用归属日期', trigger: 'blur' },
          ],
          repairReson: [ // 申请原因
            { required: true, message: '请输入申请原因', trigger: 'blur' },
          ],
          amtRemark: [ // 费用说明
            { required: true, message: '请输入费用说明', trigger: 'blur' },
          ],
          afterPicFile: [ // 上传附件
            { required: true, message: '请选择上传附件', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async handleOrgIdChange () {
      await this.$emit('getOtherFormVal', {
        from: 'detailForm',
        tar: 'baseForm',
      });
    },

    async handleSiteChange () {
      const site = this.$refs.baseForm.getVal('site');
      this.$refs.baseForm.setVal('serviceName', site.serviceName);
      await this.$emit('getOtherFormVal', {
        from: 'detailForm',
        tar: 'baseForm',
      });
    },

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'REPAIR_APPLY_TYPE,REPAIR_APPLY_STATE',
      });
      this.baseForm.applyTypeOptions = enumsList[0]; // 费用类型
      this.baseForm.stateOptions = enumsList[1]; // 维保状态
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 维修站点
        formData.serviceName = formData.site.serviceName;
        formData.serviceId = formData.site.serviceUserId;
        formData.productName = formData.site.productName;
        formData.productId = formData.site.productId;
        delete formData.site;
        // 费用归属日期
        formData.feeAscriptionDate = this.formatDate(formData.feeAscriptionDate, 1);
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData.afterPicFile) {
        formData.afterPicFileIds = formData.afterPicFile.map((item) => item.id);
        formData.afterPicFileIds = formData.afterPicFileIds.join(',');
      }
      delete formData.afterPicFile;
      formData.workType = formData.applyType;
      formData.vehicleFeeFileDetails = '';
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (data.costDetails) {
        data = {
          ...data,
          ...data.costDetails[0],
        };
      }
      // 费用类型
      if (data.applyType !== undefined && data.applyType !== null) {
        data.applyType = String(data.applyType);
      }
      // 维修站点
      data.site = {
        serviceUserId: data.serviceId,
        serviceName: data.serviceName,
        productName: data.productName,
        productId: data.productId,
      };
      if (data.afterPicList) {
        data.afterPicFile = data.afterPicList.map((item) => ({
          id: item.fileId || item.id,
          url: item.fileUrl || item.url,
        }));
      } else {
        data.afterPicFile = [];
      }
      this.$refs.baseForm.setVal('form', data);
      await this.handleOrgIdChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
